export const SCE_MODULES = {
    accessibility: 'accessibility',
    misspelling: 'spelling',
    readability: 'readability',
    language_match: 'language_match',
} as const;
